// Data da pelada para exibição, sempre no dia certo de Brasília, qualquer que seja o fuso do aparelho.
// Peladas antigas foram gravadas à meia-noite UTC (só a data); as novas, no horário de início em Brasília
// (ex.: 29/09 20:00 = 29/09 23:00 UTC). Mesma regra de `diaDaPelada` na API.
export const dataPelada = (date, formato = { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' }) => {
  if (!date) return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const soData = d.getUTCHours() === 0 && d.getUTCMinutes() === 0;
  return d.toLocaleDateString('pt-BR', { ...formato, timeZone: soData ? 'UTC' : 'America/Sao_Paulo' });
};

export default dataPelada;
